/**
 * LearnOS Service Worker Registration Helper
 */

export function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve(null);
  }

  // Register on window load to avoid competing with critical rendering resources
  return new Promise((resolve) => {
    const doRegister = async () => {
      try {
        const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
        console.log('[LearnOS PWA] Service worker registered with scope:', reg.scope);

        // Check for updates periodically or on controller change
        reg.onupdatefound = () => {
          const installingWorker = reg.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (
                installingWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                console.log('[LearnOS PWA] New static assets ready. Will activate on next session.');
              }
            };
          }
        };

        resolve(reg);
      } catch (err) {
        console.warn('[LearnOS PWA] Service worker registration failed:', err);
        resolve(null);
      }
    };

    if (document.readyState === 'complete') {
      doRegister();
    } else {
      window.addEventListener('load', () => {
        doRegister();
      });
    }
  });
}
